import LeadDetails from "./LeadDetails";

export default LeadDetails;
